/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for audio high icon.
 *
 * @author Hari Gangadharan
 */
const AudioHigh = props => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      d="M11.982 4.092a.498.498 0 1 0-.579.813A3.808 3.808 0 0 1 13.005
      8a3.806 3.806 0 0 1-1.602 3.094.498.498 0 1 0 .579.813A4.803 4.803
      0 0 0 14.004 8a4.804 4.804 0 0 0-2.022-3.908M9.696.04a.503.503 0 0
      0-.542.098L4.061 5H1.727C.775 5 0 5.784 0 6.75v2.5C0 10.214.775 11
      1.727 11h2.334l5.093 4.861a.503.503 0 0 0 .542.1.5.5 0 0 0
      .304-.46V.5a.5.5 0 0 0-.304-.46"
    />
    <path
      d="M14.084 2.102a.5.5 0 0 0-.61.792A6.395 6.395 0 0 1 16.002 8a6.394
      6.394 0 0 1-2.526 5.104.5.5 0 1 0 .609.792A7.386 7.386 0 0 0 17 8a7.388
      7.388 0 0 0-2.916-5.897"
    />
  </SvgIcon>
);

export default AudioHigh;



// WEBPACK FOOTER //
// ./src/js/icons/AudioHigh.jsx